import type { AppContextType } from '../components/AppContext';
import type { Experience } from '../types';

export default (context: AppContextType, experience: Experience): string => {
  const { localeConfig, locale } = context;
  return localeConfig?.[locale]?.[experience]?.domain ?? '';
};
